import React from 'react'
import LinkBox from './LinkBox';
import { useIntl } from 'react-intl';

export type EnergyEffLinkBoxRowProps = {};

const EnergyEffLinkBoxRow: React.FC<EnergyEffLinkBoxRowProps> = () => {
  const intl = useIntl()
  return (
    <>
    <div className="w-full gap-2 flex flex-col md:flex-row items-center justify-center max-w-5xl m-auto pt-20 px-4 md:px-2 lg:px-0">
      <div className="w-full md:w-1/3">
        <LinkBox href={"/energy-efficiency/NOM-029-ENER-2017"} label={"NOM-029-ENER-2017"} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"/energy-efficiency/NOM-032-ENER-2013"} label={"NOM-032-ENER-2013"} />
      </div>
    </div>
    <div className="w-full gap-2 flex flex-col md:flex-row items-center justify-center max-w-5xl m-auto pt-2 px-4 md:px-2 lg:px-0">
      <div className="w-full md:w-1/3">
        <LinkBox href={"#Certificados_Vigentes"} label={intl.formatMessage({id: "curr-certs"})} />
      </div>
      <div className="w-full md:w-1/3">
        <LinkBox href={"#Certificados_Cancelados"} label={intl.formatMessage({id: "can_certs"})} />
      </div>
    </div>
    </>
  );
}

export default EnergyEffLinkBoxRow;